import {currentUser, apiUrl} from '@/constants/config';
import axios from 'axios';

export default {
    state: {
        currentUser: (localStorage.getItem('user') != null) ? JSON.parse(localStorage.getItem('user')) : null,
        token: (localStorage.getItem('token') != null) ? localStorage.getItem('token') : null,
        loginError: null,
        processing: false
    },
    getters: {
        currentUser: state => state.currentUser,
        token: state => state.token,
        processing: state => state.processing,
        loginError: state => state.loginError
    },
    mutations: {
        setUser(state, payload) {
            state.currentUser = payload;
            state.token = payload.token;
            state.processing = false;
            state.loginError = null;
        },
        setLogout(state) {
            state.currentUser = null;
            state.processing = false;
            state.loginError = null;
        },
        setProcessing(state, payload) {
            state.processing = payload;
            state.loginError = null;
        },
        setError(state, payload) {
            state.loginError = payload;
            state.currentUser = null;
            state.processing = false;
        },
        clearError(state) {
            state.loginError = null;
        }
    },
    actions: {
        signOut({commit}) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            commit('setLogout');
        },

        makeLoginRequest({}, payload) {
            return new Promise((resolve, reject) => {
                axios.post(apiUrl + 'api/user/login', payload).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log('err', err);
                    reject(err.response);
                });
            });
        },

        login({}, payload) {
            return new Promise((resolve, reject) => {
                axios.get(apiUrl + 'api/user/login/' + payload).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log('err', err);
                    reject(err.response);
                });
            });
        },

        logout({}, payload) {
            return new Promise((resolve, reject) => {
                axios.post(apiUrl + 'api/user/logout/', {session: payload}).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log('err', err);
                    reject(err.response);
                });
            });
        },

        getAccounts({}, secret) {
            return new Promise((resolve, reject) => {
                axios.get(apiUrl + 'api/user/accounts/' + secret).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },

        getMessages({}, secret) {
            return new Promise((resolve, reject) => {
                axios.get(apiUrl + 'api/user/comm/' + secret).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },

        getMessage({}, data) {
            return new Promise((resolve, reject) => {
                axios.get(apiUrl + 'api/user/comm/' + data.secret + '/' + data.id).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },

        // Contact information. These reject with the whole response so the
        // page can act on the status and the {error} code the api returns.
        getContact({}, session) {
            return new Promise((resolve, reject) => {
                axios.get(apiUrl + 'api/user/contact/' + session).then(response => {
                    resolve(response.data);
                }, err => {
                    reject(err.response);
                });
            });
        },

        sendContactCode({}, {session, field, value}) {
            return new Promise((resolve, reject) => {
                axios.post(apiUrl + 'api/user/contact/' + session + '/send-code', {field, value}).then(response => {
                    resolve(response.data);
                }, err => {
                    reject(err.response);
                });
            });
        },

        verifyContactCode({}, {session, field, value, code}) {
            return new Promise((resolve, reject) => {
                axios.post(apiUrl + 'api/user/contact/' + session + '/verify-code', {field, value, code}).then(response => {
                    resolve(response.data);
                }, err => {
                    reject(err.response);
                });
            });
        },

        saveContactAddress({}, {session, ...address}) {
            return new Promise((resolve, reject) => {
                axios.post(apiUrl + 'api/user/contact/' + session + '/address', address).then(response => {
                    resolve(response.data);
                }, err => {
                    reject(err.response);
                });
            });
        }
    }
}
